export default [
  {
    path: '/count',
    name: 'count',
    component: () => import('@/pages/count/count.vue')
  },
]